import type { NavItem, UserRole } from '@leoclinic/types';

/**
 * Itens de navegação da sidebar — filtrados por role
 */
export const NAV_ITEMS: NavItem[] = [
  { title: 'Dashboard', href: '/', icon: 'LayoutDashboard' },
  { title: 'Agenda', href: '/agenda', icon: 'Calendar', roles: ['administrator', 'receptionist', 'therapist'] },
  { title: 'Marcações', href: '/appointments', icon: 'CalendarCheck', roles: ['administrator', 'receptionist'] },
  { title: 'Clientes', href: '/clients', icon: 'Users', roles: ['administrator', 'receptionist', 'therapist'] },
  { title: 'Tratamentos', href: '/treatments', icon: 'Sparkles', roles: ['administrator', 'receptionist'] },
  { title: 'Terapeutas', href: '/therapists', icon: 'UserCheck', roles: ['administrator', 'receptionist'] },
  { title: 'Pagamentos', href: '/payments', icon: 'CreditCard', roles: ['administrator', 'receptionist'] },
  { title: 'Relatórios', href: '/reports', icon: 'BarChart3', roles: ['administrator'] },
  { title: 'Marketing', href: '/marketing', icon: 'Megaphone', roles: ['administrator'] },
  { title: 'Definições', href: '/settings', icon: 'Settings', roles: ['administrator'] },
];

/**
 * Filtra itens de navegação pelo role do utilizador
 */
export function getNavItemsForRole(role: UserRole): NavItem[] {
  return NAV_ITEMS.filter((item) => !item.roles || item.roles.includes(role));
}
